'use client'

// https://stackoverflow.com/questions/78178792/how-to-use-axe-core-with-nextjs-app-router

import React from 'react'

// @@TODO: DequeAxe.tsx and reportAccessibility.tsx are similar.

// NOTE: This works, but Deque suggests to use their new product for React 18+.

const DequeAxe = () => {
  if (typeof window !== 'undefined' && process.env.NODE_ENV !== 'production') {
    Promise.all([import('@axe-core/react'), import('react-dom')])
      .then(([axe, ReactDOM]) => axe.default(React, ReactDOM, 1000))
      .catch((error) => {
        console.log('axe error:', error)
      })
  }
  return null
}

export default DequeAxe
